export default class LogMessage {
    constructor(logger, level, msg, additionalProps) {
        this.logger = logger;
        this.level = level;
        this.msg = msg;
        this.additionalProps = additionalProps;
    }
}
